import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    Button,
} from "@mui/material";

export default function CropSuggestionDialog({
    open,
    onClose,
    translate,
    suggestionType,
    setSuggestionType,
    suggestionCropType,
    setSuggestionCropType,
    suggestedValue,
    setSuggestedValue,
    cropTypes,
    onSubmit,
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                {translate("suggest_crop")}
            </DialogTitle>

            <DialogContent>
                <TextField
                    select
                    label={translate(
                        "suggestion_type"
                    )}
                    fullWidth
                    value={suggestionType}
                    onChange={(e) =>
                        setSuggestionType(
                            e.target.value
                        )
                    }
                    sx={{ mt: 2 }}
                >
                    <MenuItem value="crop_type">
                        {translate(
                            "crop_type"
                        )}
                    </MenuItem>

                    <MenuItem value="crop_variety">
                        {translate(
                            "crop_variety"
                        )}
                    </MenuItem>
                </TextField>

                {suggestionType ===
                    "crop_variety" && (
                    <TextField
                        select
                        label={translate(
                            "crop_type"
                        )}
                        fullWidth
                        value={
                            suggestionCropType
                        }
                        onChange={(e) =>
                            setSuggestionCropType(
                                e.target.value
                            )
                        }
                        sx={{ mt: 2 }}
                    >
                        {cropTypes.map((t) => (
                            <MenuItem
                                key={
                                    t.crop_type_id
                                }
                                value={
                                    t.crop_type_id
                                }
                            >
                                {t.crop_name}
                            </MenuItem>
                        ))}
                    </TextField>
                )}

                <TextField
                    label={translate(
                        "crop_name"
                    )}
                    fullWidth
                    value={suggestedValue}
                    onChange={(e) =>
                        setSuggestedValue(
                            e.target.value
                        )
                    }
                    sx={{ mt: 2 }}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    {translate("cancel")}
                </Button>

                <Button
                    variant="contained"
                    onClick={onSubmit}
                >
                    {translate("submit")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}